import fp from "lodash/fp";

/**
 * Inserts document to the beginning of the array,
 * taking page size into account.
 */
export const insertDocument = <TDocument extends { id: number }>(
	document: TDocument[],
	newDocument: TDocument,
	isFirst: boolean = true,
): TDocument[] => {
	const data = isFirst ? [newDocument, ...document] : [...document, newDocument];
	return data.slice(0, 50);
};

export const removeDocument = <TDocument extends { id: number }>(
	documents: TDocument[],
	deletedDocumentId: number,
): TDocument[] => {
	return fp.remove(doc => deletedDocumentId === doc.id, documents);
};
